"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";

export const PREV_PATH_KEY = "prevPath";

export default function NavigationTracker() {
  const pathname = usePathname();
  const prevRef = useRef<string | null>(null);

  useEffect(() => {
    if (prevRef.current !== null && prevRef.current !== pathname) {
      sessionStorage.setItem(PREV_PATH_KEY, prevRef.current);
    }
    prevRef.current = pathname;
  }, [pathname]);

  return null;
}
